import React,{ Component } from 'react'
import ReactDOM from 'react-dom'
import ImgCodeInput from "../BsyImgCodeInput";
import './index.css'

class BsyAlertImgCode extends Component{

    
    imgCodeValue = (ref) =>{
        this.imgCode = ref
    }
    getValue = () => {
        const {value} = this.imgCode.getValue();
        return value
    }

    onCancelEvent = ()=> {
        let {target} = this.props
        document.getElementsByTagName("body")[0].removeChild(target.parentNode)
        ReactDOM.unmountComponentAtNode(target)
    }
    onOKEvent = ()=> {
        if(this.props.onOk) {
            this.props.onOk({
                value:this.getValue(),
                onChange:()=>{
                    this.imgCode.changeCode()
                },
                onClose:()=>{
                    let {target} = this.props
                    document.getElementsByTagName("body")[0].removeChild(target.parentNode)
                    ReactDOM.unmountComponentAtNode(target)
                }
            });
        }
    }
    render() {
        let {type, title} = this.props
 
        return (
            <div className={"content " + type}>
                <div className="title">
                    {title}
                </div>
                <ImgCodeInput getValue={this.imgCodeValue} />
                <div className="bottom-btn">
                    <button onClick={(e)=>{this.onCancelEvent()}} className="cancel-btn">
                        {React.language('cancel')}
                    </button>
                    <button onClick={(e)=>{this.onOKEvent()}} className="ok-btn">
                        {React.language('ok')}
                    </button>
                </div>
            </div>
        )
    }
}

export default BsyAlertImgCode